<template>
    <div>
        <b-modal
            id="pricelist-assign-to-events-modal"
            title="Assegna a gallerie"
            @show="reset"
            @hidden="reset"
            @ok="save"
        >

            <div class="container-fluid flex-grow-1" v-show="loaded">
                <table class="tabella-responsive table table-striped mt-3 mb-0" v-show="events.length > 0">
                    <thead>
                    <tr>
                        <th scope="col" class="align-middle px-1 text-center"></th>
                        <th scope="col" class="align-middle px-1 text-center">{{ $t("Galleria") }}</th>
                        <th scope="col" class="align-middle px-1 text-center">{{ $t("Listino") }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(event) in events" :key="event.idEvento">
                        <td class="align-middle px-1 text-center">
                            <input class="form-check-input m-0 position-static" type="checkbox"
                                   :checked="event.selected" :disabled="event.selected"
                                   @click="manageEvent($event, event)">
                        </td>
                        <td class="align-middle px-1 text-center">{{ event.title }}</td>
                        <td class="align-middle px-1 text-center">{{ event.pricelistName }}</td>
                    </tr>
                    </tbody>
                </table>

                <div v-show="events.length === 0">
                    {{ $t("Nessuna galleria trovata") }}
                </div>
            </div>

            <div class="text-center" v-show="!loaded">
                <b-spinner variant="primary" class="btn-primary" type="grow" label="Spinning"></b-spinner>
                <br>
                <p>{{ $t("Caricamento") }}</p>
            </div>

            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button class="btn btn-light border" @click="cancel()">
                    {{ $t("Annulla") }}
                </b-button>
                <b-button class="btn btn-primary btn-rikorda1" @click="ok()" :disabled="!loaded">
                    {{ $t("Salva") }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: "PricelistAssignToEventsModal",
        props: ["pricelistId"],

        data() {
            return {
                loaded: false,
                events: [],
                selectedEvents: [],
            };
        },

        methods: {
            load() {
                this.reset();
                if (this.pricelistId.length > 0) {
                    return this.$api.backendGetEventsList()
                        .then((response) => {
                            this.events = response.events;
                            for (var i = 0; i < this.events.length; i++) {
                                this.events[i].selected = this.events[i].pricelistId === this.pricelistId;
                            }
                            this.loaded = true;
                            return true;
                        })
                        .catch(error => {
                            console.error(error);
                            this.loaded = false;
                            return false;
                        });
                } else {
                    return false;
                }
            },

            manageEvent($event, event) {
                var index, checked = $event.target.checked;
                var eventId = event.eventId;

                if (checked) {
                    this.selectedEvents.push(eventId);
                } else {
                    index = this.selectedEvents.indexOf(eventId);
                    if (index > -1) {
                        this.selectedEvents.splice(index, 1);
                    }
                }
            },

            save() {
                if (this.selectedEvents.length > 0) {
                    return this.$api.backendUpdateEventsPricelist(this.pricelistId, this.selectedEvents)
                        .then((response) => {
                            this.close(true);
                        })
                        .catch(error => {
                            console.error(error);
                        });
                } else {
                    this.close(false);
                }
            },

            reset() {
                this.loaded = false;
                this.events = [];
            },

            close(update) {
                this.$emit("close", {update: update});
            },
        }
    };
</script>

<style></style>
